export enum Role {
  ROLE_DEALER = "DEALER",
  ROLE_DEALER_EUR = "DEALER_EUR",
  ROLE_DEALER_JP = "DEALER_JP",
  ROLE_ADMIN = "ADMIN",
  ROLE_STELLANTIS_HQ = "STELLANTIS-HQ",
  ROLE_HQ = "HQ",
  HQ_NOADMIN = "HQ_NOADMIN",
  ROLE_IMPORTER = "IMPORTER",
  ROLE_SUBREGION = "SUBREGION",
  ROLE_IAP_ADMIN = "IAP-ADMIN",
  ROLE_IAP_ADMIN_TA = "IAP-ADMIN_TA",
  ROLE_IAP_DEALER = "IAP_DEALER",
  MASERATI_DEFAULT_BRAND = "b_MASE",
  IAP_DEFAULT_REGION = "IAP",
  DEALER_GROUP = "DEALER_GROUP",
  DEALER_GROUP_EUR = "DEALER_GROUP_EUR",
  DEALER_MEA_TR = "DEALER_MEA_TR",
  MASERATI_ADMIN = "MASERATI_ADMIN",
  MASERATI_SUBREGION = "MASERATI_SUBREGION",
  MASERATI_IMPORTER = "MASERATI_IMPORTER",
  MASERATI_DEALER = "MASERATI_DEALER",
  MASE_MARKET = "MASE_MARKET",
  MASE_CEC_REGION = "MASE_CEC_REGION",
  IAP_DEALER = "IAP_DEALER",
  IMPORTER = "IMPORTER",
  MEA_IMPORTER = "MEA_IMPORTER",
  ROLE_DEFAULT = "ROLE_DEFAULT",
  MARKET_EUR = "MARKET_EUR",
  MARKET_EUR_ASKROAR = "MARKET_EUR_ASKROAR",
  MARKET = "MARKET",
  STLA_REGION = "STLA_REGION",
  ADMIN_SA = "ADMIN-SA",
  STLA_REGION_SA = "STLA_REGION_SA",
  ADMIN_SA_NOA = "ADMIN_SA_NOA",
  IMPORTER_DR = "IMPORTER-DR",
  ROLE_IMPORTER_UPLOAD = "IMPORTER-UPLOAD",
  DEALER_UPLOAD = "DEALER-UPLOAD",
  ROLE_APPEAL_REGION = "ROLE-APPEAL-REGION",
  ROLE_APPEAL_MARKET = "ROLE-APPEAL-MARKET",
  ROLE_APPEAL_DEALER = "ROLE-APPEAL-DEALER",
  CEC_ADMIN = "CEC_ADMIN",
  CEC_SUPPLIER = "CEC_SUPPLIER",
  CEC_GLOBAL = "CEC_GLOBAL",
  CEC_ADMIN_MASE = "CEC_ADMIN_MASE",
  CEC_SUPPLIER_MASE = "CEC_SUP_MASE",
  CEC_GLOBAL_MASE = "CEC_GLOBAL_MASE",
  ROLE_IMPORTER_MEA = "IMPORTER-MEA",
  APPEAL_USER_PROCESS = "APPEAL_USER_PROCESS",
  ROLE_DEALER_EUR_NOA = "DEALER_EUR_NOA",
  STLA_HQ_no_TA = "STLA-HQ_no-TA",
  DEALER_TA = "DEALER_TA",
  DEALER_TA_AP = "DEALER_TA_AP",
  DEALER_MASE_TA = "DEALER_MASE_TA",
  DEALER_EUR_TA = "DEALER_EUR_TA",
  DEAL_EUR_NOA_TA = "DEAL_EUR_NOA_TA",
  DEALER_GROUP_TA = "DEALER_GROUP_TA",
  DEALER_SA = "DEALER_SA",
  DEALER_GROUP_SA = "DEALER_GROUP_SA",
  MARKET_SA = "MARKET_SA",
  MARKET_SA_NOA = "MARKET_SA_NOA",
  STELLANTIS_HQ_SA = "STELLANTIS-HQ_SA",
  ADMIN_HQ_B2E = "ADMIN-HQ_B2E",
  STLA_HQ_TA_TEST = "STLA-HQ-TA-TEST",
  STLA_HQ_TA = "STLA-HQ-TA",
  STLA_HQ_TA_P1 = "STLA-HQ-TA-P1",
  STLA_DR = "STELLANTIS-DR",
  STLA_DR_HQ = "STLA-DR-HQ",
  ASEAN_REGION = "ASEAN_REGION",
  ASEAN_MARKET = "ASEAN_MARKET",
  DEALER_DR = "DEALER_DR",
  GROUP = "GROUP",
  DEALER_GROUP_EUR_NOA = "DEALER_GROUP_EUR_NOA",
  DEAL_GROUP_EUR_NOA_TA = "DEAL_GROUP_EUR_NOA_TA",
  MEA_HQ = "MEA-HQ",
  IAP_MARKET = "IAP_MARKET",
  ROAR_OR_ADMIN = "ROAR_OR_ADMIN",
  HQ = "HQ"
}